// Vendor libraries
import { ChangeDetectorRef, ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import scrollIntoView from 'scroll-into-view-if-needed';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/dropdown-helper.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../apps/entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i6 from "@angular/forms";
import * as i7 from "../../modals/help-modal/components/help-modal.component";
const _c0 = ["singleSelectDropdown"];
const _c1 = ["scrollTargetEl"];
const _c2 = a0 => ({ "pointer-events": a0 });
const _c3 = a0 => ({ show: a0 });
const _c4 = a0 => ({ "dropdown-more": a0 });
const _c5 = a0 => ({ "custom-checkbox-tall": a0 });
const _c6 = a0 => ({ "disabled": a0 });
function SingleSelectDropdownComponent_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", !ctx_r1.isInHeader ? "text-default" : "", " placeholder");
    i0.ɵɵproperty("textContent", ctx_r1.placeholderText);
} }
function SingleSelectDropdownComponent_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(!ctx_r1.isInHeader ? "text-default" : "");
    i0.ɵɵproperty("textContent", (ctx_r1.configCopy.title == null ? null : ctx_r1.configCopy.title.label) + ": ");
} }
function SingleSelectDropdownComponent_span_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
} if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate2("", !ctx_r1.isInHeader ? "text-default" : "", " ", ctx_r1.customCssClasses.dropdownItem, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c4, !!(ctx_r1.configCopy.title == null ? null : ctx_r1.configCopy.title.label)))("textContent", (tmp_6_0 = ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.selectedLabel) !== null && tmp_6_0 !== undefined ? tmp_6_0 : ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.label);
} }
function SingleSelectDropdownComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, SingleSelectDropdownComponent_span_3_span_1_Template, 1, 4, "span", 7)(2, SingleSelectDropdownComponent_span_3_span_2_Template, 1, 4, "span", 7)(3, SingleSelectDropdownComponent_span_3_span_3_Template, 1, 8, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.placeholderText && !ctx_r1.selectedItem);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configCopy.title == null ? null : ctx_r1.configCopy.title.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!(ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.label) || !!(ctx_r1.selectedItem == null ? null : ctx_r1.selectedItem.selectedLabel));
} }
function SingleSelectDropdownComponent_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.customSublabel);
} }
function SingleSelectDropdownComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "span", 9);
    i0.ɵɵtemplate(2, SingleSelectDropdownComponent_span_4_span_2_Template, 1, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("", !ctx_r1.isInHeader ? "text-default" : "", " ", ctx_r1.customCssClasses.dropdownItem, "");
    i0.ɵɵproperty("textContent", ctx_r1.customLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r1.customSublabel);
} }
function SingleSelectDropdownComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} }
function SingleSelectDropdownComponent_div_6_div_2_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", null, 2);
} }
function SingleSelectDropdownComponent_div_6_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleSelectDropdownComponent_div_6_div_2_ng_container_1_span_1_Template, 2, 0, "span", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r3.selected);
} }
function SingleSelectDropdownComponent_div_6_div_2_label_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", listItem_r3.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", listItem_r3.description);
} }
function SingleSelectDropdownComponent_div_6_div_2_label_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 26);
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("textContent", listItem_r3.label);
} }
function SingleSelectDropdownComponent_div_6_div_2_label_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 27);
    i0.ɵɵlistener("click", function SingleSelectDropdownComponent_div_6_div_2_label_3_ng_container_5_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r5); const listItem_r3 = i0.ɵɵnextContext(3).$implicit; i0.ɵɵnextContext(); const helpModal_r6 = i0.ɵɵreference(8); helpModal_r6.openModal(listItem_r3.helpName); return i0.ɵɵresetView(false); });
    i0.ɵɵtext(4, "(?)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function SingleSelectDropdownComponent_div_6_div_2_label_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 19)(1, "input", 20);
    i0.ɵɵlistener("change", function SingleSelectDropdownComponent_div_6_div_2_label_3_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r4); const listItem_r3 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleChange(listItem_r3)); });
    i0.ɵɵtwoWayListener("ngModelChange", function SingleSelectDropdownComponent_div_6_div_2_label_3_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const listItem_r3 = i0.ɵɵnextContext(2).$implicit; i0.ɵɵtwoWayBindingSet(listItem_r3.selected, $event) || (listItem_r3.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵtemplate(3, SingleSelectDropdownComponent_div_6_div_2_label_3_span_3_Template, 3, 2, "span", 22)(4, SingleSelectDropdownComponent_div_6_div_2_label_3_span_4_Template, 1, 1, "span", 23)(5, SingleSelectDropdownComponent_div_6_div_2_label_3_ng_container_5_Template, 5, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, listItem_r3.description))("disabled", listItem_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", listItem_r3.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", listItem_r3.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !listItem_r3.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r3.helpName);
} }
function SingleSelectDropdownComponent_div_6_div_2_div_4_label_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 32)(1, "input", 33);
    i0.ɵɵlistener("change", function SingleSelectDropdownComponent_div_6_div_2_div_4_label_3_Template_input_change_1_listener() { const sublistItem_r9 = i0.ɵɵrestoreView(_r8).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.handleChange(sublistItem_r9)); });
    i0.ɵɵtwoWayListener("ngModelChange", function SingleSelectDropdownComponent_div_6_div_2_div_4_label_3_Template_input_ngModelChange_1_listener($event) { const sublistItem_r9 = i0.ɵɵrestoreView(_r8).$implicit; i0.ɵɵtwoWayBindingSet(sublistItem_r9.selected, $event) || (sublistItem_r9.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 21)(3, "span", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sublistItem_r9 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c6, sublistItem_r9.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !!sublistItem_r9.disabled);
    i0.ɵɵtwoWayProperty("ngModel", sublistItem_r9.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", sublistItem_r9.label, i0.ɵɵsanitizeHtml);
} }
function SingleSelectDropdownComponent_div_6_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵlistener("click", function SingleSelectDropdownComponent_div_6_div_2_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const listItem_r3 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleSublist(listItem_r3)); });
    i0.ɵɵelement(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtemplate(3, SingleSelectDropdownComponent_div_6_div_2_div_4_label_3_Template, 4, 6, "label", 31);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3, !!listItem_r3.open))("disabled", listItem_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", listItem_r3.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3, !!listItem_r3.open));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", listItem_r3.sublist);
} }
function SingleSelectDropdownComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SingleSelectDropdownComponent_div_6_div_2_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtemplate(3, SingleSelectDropdownComponent_div_6_div_2_label_3_Template, 6, 8, "label", 17)(4, SingleSelectDropdownComponent_div_6_div_2_div_4_Template, 4, 9, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.scrollToSelected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", !!listItem_r3.sublist);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", true);
} }
function SingleSelectDropdownComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, SingleSelectDropdownComponent_div_6_div_1_Template, 1, 0, "div", 14)(2, SingleSelectDropdownComponent_div_6_div_2_Template, 5, 4, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", listItem_r3.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "divider");
} }
/**
 *
 * Single Select Dropdown Component
 *
 * Input Properties:
 *   buttonClass: The CSS class to be applied to the button that opens the dropdown
 *   config: Please see single-select-dropdown-config.interface.ts for an example config.
 *   customCssClasses: An object containing css classes that are applied to the dropdown container, opening button, and
 *     dropdown menu.
 *   customSublabel: subtitle of custom label to be displayed if we don't want item selections to be included in the dropdown label (unbolded).
 *   customLabel: title of custom label to be displayed if we don't want item selections to be included in the dropdown label.
 *   inputDisabled: Whether the dropdown should be disabled
 *   placeHolderText: The text that should be displayed as a placeholder before any item is selected, e.g. "Select"
 *   scrollToSelected: Whether the dropdown should automatically scroll to the selected item when it is opened
 *   selectedValue: The value that is currently selected in the dropdown
 *
 * Output properties:
 *  changeHandler: EventEmitter that emits the item's value whenever a new item is selected
 *  closeHandler: EventEmitter that emits whenever the dropdown is closed
 *
 */
export class SingleSelectDropdownComponent {
    constructor(changeDetector, dropdownHelperService, featureService) {
        this.changeDetector = changeDetector;
        this.dropdownHelperService = dropdownHelperService;
        this.featureService = featureService;
        this.customCssClasses = {};
        this.inputDisabled = false;
        this.isInHeader = false;
        this.scrollToSelected = false;
        this.blockInput = false;
        this.changeHandler = new EventEmitter();
        this.closeHandler = new EventEmitter();
        this.openHandler = new EventEmitter();
        this.configCopy = {};
        this.isOpen = false;
        this.selectedItem = null;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.toggle();
            }
            this.changeDetector.markForCheck();
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement, autoCloseHandler);
    }
    ngOnChanges(changes) {
        if (!!changes.config && !!changes.config.currentValue) {
            this.configCopy = cloneDeep(changes.config.currentValue);
            this.selectItem(this.selectedValue);
        }
        if (changes.selectedValue) {
            const selectedValue = changes.selectedValue.currentValue;
            this.selectItem(selectedValue);
        }
    }
    toggle() {
        // Toggling is handled by hover events if it's a nested dropdown
        if (this.customCssClasses.dropdownContainer === 'dropdown-nested') {
            return;
        }
        if (!this.inputDisabled) {
            if (this.isOpen) {
                this.isOpen = false;
                this.closeHandler.emit();
            }
            else {
                this.isOpen = true;
                this.openHandler.emit();
                if (this.scrollToSelected && this.scrollTargetEl) {
                    // Scroll so that the selected dropdown item is visible
                    setTimeout(() => {
                        scrollIntoView(this.scrollTargetEl.nativeElement, {
                            block: 'center',
                            scrollMode: 'if-needed',
                        });
                    });
                }
            }
        }
        else {
            this.isOpen = false;
        }
    }
    handleChange(item) {
        // There appears to be a small bug with ngModel + checkbox. Workaround by manually detecting changes for now
        // https://github.com/angular/angular/issues/9275
        this.changeDetector.detectChanges();
        if (this.selectItem(item.value)) {
            this.changeHandler.emit(item.value);
        }
        this.toggle();
    }
    purgeSelectedValue(selectedValue) {
        for (let i = 0; i < this.configCopy.list.length; i += 1) {
            const listItem = this.configCopy.list[i];
            if (listItem.value === selectedValue)
                listItem.selected = false;
            if (listItem.sublist) {
                for (let j = 0; j < listItem.sublist.length; j += 1) {
                    const sublistItem = listItem.sublist[j];
                    if (sublistItem.value === selectedValue)
                        sublistItem.selected = false;
                }
            }
        }
    }
    selectItem(selectedValue) {
        // Return true or false to validate that item was selected
        // Some components may set the selected item to an empty string when resetting data back to the default state
        if (selectedValue === '') {
            this.selectedItem = null;
        }
        const selectedConfig = this.configCopy.list.find((item) => item.value === selectedValue);
        if (selectedConfig?.requiredFeature != null &&
            !this.featureService.userHasFeatures([selectedConfig.requiredFeature])) {
            this.featureNeededModal.openModal(selectedConfig.requiredFeature);
            this.purgeSelectedValue(selectedValue);
            return false;
        }
        // Go through and deselect/select the correct items.
        for (let i = 0; i < this.configCopy.list.length; i += 1) {
            const listItem = this.configCopy.list[i];
            if (listItem.value === selectedValue) {
                this.selectedItem = listItem;
                listItem.selected = true;
            }
            else {
                listItem.selected = false;
            }
            if (listItem.sublist) {
                for (let j = 0; j < listItem.sublist.length; j += 1) {
                    const sublistItem = listItem.sublist[j];
                    if (sublistItem.value === selectedValue) {
                        this.selectedItem = sublistItem;
                        sublistItem.selected = true;
                        listItem.open = true;
                    }
                    else {
                        sublistItem.selected = false;
                    }
                }
            }
        }
        return true;
    }
    toggleSublist(item) {
        if (!item.sublist)
            return;
        // If an item in the sublist is selected, keep it open.
        // otherwise, toggle the open/closed state of the sublist.
        let isOpen = !item.open;
        for (let i = 0; i < item.sublist.length; i += 1) {
            const sublistItem = item.sublist[i];
            if (sublistItem.selected) {
                isOpen = true;
                break;
            }
        }
        item.open = isOpen; /* eslint-disable-line no-param-reassign */
    }
}
SingleSelectDropdownComponent.ɵfac = function SingleSelectDropdownComponent_Factory(t) { return new (t || SingleSelectDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DropdownHelperService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
SingleSelectDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleSelectDropdownComponent, selectors: [["ycn-single-select-dropdown"]], viewQuery: function SingleSelectDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollTargetEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { config: "config", customCssClasses: "customCssClasses", customLabel: "customLabel", customSublabel: "customSublabel", inputDisabled: "inputDisabled", isInHeader: "isInHeader", placeholderText: "placeholderText", scrollToSelected: "scrollToSelected", selectedValue: "selectedValue", blockInput: "blockInput" }, outputs: { changeHandler: "changeHandler", closeHandler: "closeHandler", openHandler: "openHandler" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 20, consts: [["singleSelectDropdown", ""], ["helpModal", ""], ["scrollTargetEl", ""], ["ycnDisabled", "", "href", "javascript:void(0)", 3, "click", "disabled"], [4, "ngIf"], [3, "ngClass"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "class", "textContent", 4, "ngIf"], [3, "class", "ngClass", "textContent", 4, "ngIf"], [3, "textContent"], [3, "ngClass", "textContent"], ["class", "text-normal visible-md-inline", 3, "textContent", 4, "ngIf"], [1, "text-normal", "visible-md-inline", 3, "textContent"], [3, "ngSwitch"], ["class", "dropdown-divider", 4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "dropdown-divider"], ["class", "custom-control custom-checkbox dropdown-item custom-checkbox-style1", "ycnDisabled", "", 3, "ngClass", "disabled", 4, "ngSwitchCase"], ["class", "dropdown-item dropdown", "ycnDisabled", "", 3, "ngClass", "disabled", "click", 4, "ngSwitchCase"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1", 3, "ngClass", "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], ["class", "custom-control-description dropdown-item-text", 4, "ngIf"], ["class", "custom-control-description", 3, "textContent", 4, "ngIf"], [1, "custom-control-description", "dropdown-item-text"], [1, "dropdown-item-description", 3, "textContent"], [1, "custom-control-description", 3, "textContent"], [1, "help-toggler", 3, "click"], ["ycnDisabled", "", 1, "dropdown-item", "dropdown", 3, "click", "ngClass", "disabled"], [1, "dropdown-toggle", 3, "innerHTML"], [1, "dropdown-menu", 3, "ngClass"], ["class", "custom-control custom-checkbox dropdown-item custom-checkbox-style1", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1", 3, "ngClass"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "disabled", "ngModel"], [1, "custom-control-description", 3, "innerHTML"]], template: function SingleSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", null, 0)(2, "a", 3);
        i0.ɵɵlistener("click", function SingleSelectDropdownComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggle()); });
        i0.ɵɵtemplate(3, SingleSelectDropdownComponent_span_3_Template, 4, 3, "span", 4)(4, SingleSelectDropdownComponent_span_4_Template, 3, 6, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, SingleSelectDropdownComponent_div_6_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(7, "ycn-help-modal", null, 1)(9, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("dropdown ", ctx.customCssClasses.dropdownContainer, "");
        i0.ɵɵadvance(2);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(16, _c2, ctx.blockInput ? "none" : "auto"));
        i0.ɵɵclassMapInterpolate1("", ctx.customCssClasses.button, " dropdown-toggle user-select-none");
        i0.ɵɵproperty("disabled", !!ctx.inputDisabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.customLabel);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !!ctx.customLabel);
        i0.ɵɵadvance();
        i0.ɵɵclassMapInterpolate1("dropdown-menu ", ctx.customCssClasses.dropdownMenu, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c3, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.configCopy.list);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i3.NgSwitchDefault, i4.DisabledDirective, i5.FeatureNeededComponent, i6.CheckboxControlValueAccessor, i6.NgControlStatus, i6.NgModel, i7.HelpModalComponent], encapsulation: 2, changeDetection: 0 });
